import { helpers } from '@vuelidate/validators';

export const passwordRule = helpers.withMessage(
  'Password must contain at least one uppercase letter and one number',
  helpers.regex(/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&[\]]{8,}$/),
);
